/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ng2-adsense';
import * as i2 from '@angular/common';
export const AdsenseModuleNgFactory:i0.NgModuleFactory<i1.AdsenseModule> = i0.ɵcmf(i1.AdsenseModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,([] as any[])],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(4608,
          i2.NgLocalization,i2.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(512,i2.CommonModule,
          i2.CommonModule,([] as any[])),i0.ɵmpd(512,i1.AdsenseModule,i1.AdsenseModule,
          ([] as any[]))]);
    });
const styles_AdsenseComponent:any[] = ([] as any[]);
export const RenderType_AdsenseComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AdsenseComponent,data:{}});
export function View_AdsenseComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),3,'ins',[['class','adsbygoogle']],[[1,'data-ad-client',
          0],[1,'data-ad-slot',0],[1,'data-ad-format',0],[1,'data-ad-region',0],[1,
          'data-layout',0],[1,'data-layout-key',0]],(null as any),(null as any),(null as any),
      (null as any))),i0.ɵdid(2,278528,(null as any),0,i2.NgStyle,[i0.KeyValueDiffers,
      i0.ElementRef,i0.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),i0.ɵpod(3,
      {'display':0,'width.px':1,'height.px':2}),(_l()(),i0.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:i1.AdsenseComponent = _v.component;
    const currVal_6:any = _ck(_v,3,0,_co.display,_co.width,_co.height);
    _ck(_v,2,0,currVal_6);
  },(_ck,_v) => {
    var _co:i1.AdsenseComponent = _v.component;
    const currVal_0:any = _co.adClient;
    const currVal_1:any = _co.adSlot;
    const currVal_2:any = _co.adFormat;
    const currVal_3:any = _co.adRegion;
    const currVal_4:any = _co.layout;
    const currVal_5:any = _co.layoutKey;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  });
}
export function View_AdsenseComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'ng2-adsense',
      ([] as any[]),(null as any),(null as any),(null as any),View_AdsenseComponent_0,
      RenderType_AdsenseComponent)),i0.ɵdid(1,4308992,(null as any),0,i1.AdsenseComponent,
      [i1.ADSENSE_CONFIG],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AdsenseComponentNgFactory:i0.ComponentFactory<i1.AdsenseComponent> = i0.ɵccf('ng2-adsense,ng-adsense',
    i1.AdsenseComponent,View_AdsenseComponent_Host_0,{adClient:'adClient',adSlot:'adSlot',
        adFormat:'adFormat',adRegion:'adRegion',display:'display',width:'width',height:'height',
        layout:'layout',layoutKey:'layoutKey'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9ub2RlX21vZHVsZXMvbmcyLWFkc2Vuc2UvaW5kZXgubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM5NDYzMjk0NzAvc3JjL2Zyb250ZW5kL25vZGVfbW9kdWxlcy9uZzItYWRzZW5zZS9pbmRleC5kLnRzIiwibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM5NDYzMjk0NzAvc3JjL2Zyb250ZW5kL25vZGVfbW9kdWxlcy9uZzItYWRzZW5zZS9pbmRleC5kLnRzLkFkc2Vuc2VDb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9ub2RlX21vZHVsZXMvbmcyLWFkc2Vuc2UvaW5kZXguZC50cy5BZHNlbnNlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gIDxpbnMgY2xhc3M9XCJhZHNieWdvb2dsZVwiXG4gICAgW25nU3R5bGVdPVwieydkaXNwbGF5JzogZGlzcGxheSwgJ3dpZHRoLnB4Jzogd2lkdGgsICdoZWlnaHQucHgnOiBoZWlnaHQgfVwiXG4gICAgW2F0dHIuZGF0YS1hZC1jbGllbnRdPVwiYWRDbGllbnRcIlxuICAgIFthdHRyLmRhdGEtYWQtc2xvdF09XCJhZFNsb3RcIlxuICAgIFthdHRyLmRhdGEtYWQtZm9ybWF0XT1cImFkRm9ybWF0XCJcbiAgICBbYXR0ci5kYXRhLWFkLXJlZ2lvbl09XCJhZFJlZ2lvblwiXG4gICAgW2F0dHIuZGF0YS1sYXlvdXRdPVwibGF5b3V0XCJcbiAgICBbYXR0ci5kYXRhLWxheW91dC1rZXldPVwibGF5b3V0S2V5XCI+XG4gIDwvaW5zPlxuICAiLCI8bmcyLWFkc2Vuc2U+PC9uZzItYWRzZW5zZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQSw0Q0FDRTtNQUFBO1VBQUE7VUFBQTtNQUFBLHVCQUFBOytCQUFBLGdEQUNFO01BQUEsMENBTW1DO01BQy9COztJQVBKO0lBREYsV0FDRSxTQURGOzs7SUFFRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFQRixXQUVFLFVBQ0EsVUFDQSxVQUNBLFVBQ0EsVUFDQSxTQVBGOzs7O29CQ0RGO01BQUE7aUNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/$$_gendir/~/ng2-adsense/index.ngfactory.ts